<template>
  <svg
    v-if="position === 'left'"
    width="337"
    height="417"
    viewBox="0 0 337 417"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="styles"
  >
    <path
      :opacity="opacity"
      d="M320.179 78.7181C296.756 39.5177 225.413 -24.3979 81.6541 31.8249C45.199 45.901 9.81616 64.9693 -29.0308 51.8752C-63.1765 40.4179 -119.756 24.3776 -152.747 10.9562C-203.883 -9.25781 -266.649 -0.173787 -294.279 27.3238C-311.104 44.5098 -390.86 127.903 -276.464 259.007C-187.305 362.123 28.7036 413.436 83.6337 416.546C85.1996 416.629 86.769 416.629 88.3349 416.546C100.624 417.2 107.8 416.955 107.8 416.955C130.646 416.3 33.5697 370.962 27.3014 361.141C71.8394 354.84 311.272 324.805 335.685 156.546C339.765 129.604 334.284 102.093 320.179 78.7181Z"
      fill="white"
    />
  </svg>
  <svg
    v-if="position === 'right'"
    :class="styles"
    width="337"
    height="417"
    viewBox="0 0 337 417"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :opacity="opacity"
      d="M657.179 78.7181C633.756 39.5177 562.413 -24.3979 418.654 31.8249C382.199 45.901 346.816 64.9693 307.969 51.8752C273.823 40.4179 217.244 24.3776 184.253 10.9562C133.117 -9.25781 70.3511 -0.173787 42.7211 27.3238C25.8957 44.5098 -53.8602 127.903 60.5363 259.007C149.695 362.123 365.704 413.436 420.634 416.546C422.2 416.629 423.769 416.629 425.335 416.546C437.624 417.2 444.8 416.955 444.8 416.955C467.646 416.3 370.57 370.962 364.301 361.141C408.839 354.84 648.272 324.805 672.685 156.546C676.765 129.604 671.284 102.093 657.179 78.7181Z"
      fill="white"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  position: {
    type: String,
    default: 'left',
  },
  styles: String,
  opacity: {
    type: Number,
    default: 0.5,
  },
})
</script>
